// Fixed enums for the single "Completed Order" form — the same real values
// verified this session against the actual app/schema (fe/utils/constantData.js,
// be/constants/sectors.js, and real inline Select options in EditPurchaseDetailsForm
// / EditSampleDetailsForm), reused here rather than re-derived.
export const FIXED_OPTIONS = {
  sampleVariant: ["Normal", "Organic", "Loose"],
  sampleType: ["Whole", "Powder"],
  sector: ["Organized", "Unorganized", "e-commerce"],
  quantityUnit: ["Kg", "MT"],
  typeOfShop: ["Retail", "Kirana Shop", "Supermarket", "Mandi", "Street Vendor"],
  samplePackedIn: ["General Packing", "Special Packing"],
  yesNo: ["Yes", "No"],
  samplePhysicalCondition: ["Damaged", "Fit for analysis"],
  conditionOfSeal: ["Intact", "Tempered/Broken"],
  overallSafetyCompliant: ["Safe", "Unsafe", "Not Applicable"],
  overallQualityCompliant: ["Standard", "Sub-standard", "Not Applicable"],
  overallLabellingCompliant: ["Branded", "Mis-Labelled", "Not Applicable"],
  overallSampleClassification: ["Compliant", "Unsafe", "Sub-standard", "Mis-Labelled"],
};

// key -> label, in the same chronological order used by the Historical
// Orders sheet (see /google-sheets/historical-orders/Code.gs STAGE_LABELS).
export const STAGE_DATE_FIELDS = [
  ["pendingDate", "Pending Date"],
  ["bookedDate", "Booked Date"],
  ["inReviewDate", "In Review Date"],
  ["readyForPickupDate", "Ready for Pickup Date"],
  ["outForPickupDate", "Out for Pickup Date"],
  ["deliveredToLabDate", "Delivered to Lab Date"],
  ["receivedAtLabDate", "Received at Lab Date"],
  ["underTestingDate", "Under Testing Date"],
  ["reportUploadedDate", "Report Uploaded Date"],
];
